import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {useRefetchOnAliveUpdate} from '../../../hooks/use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useOverviewRoute} from './use-overview-route'

export const useAssigneesQuery = () => useRouteQuery(useOverviewRoute(), 'assignees')

export const useReviewRequestsQuery = () => useRouteQuery(useOverviewRoute(), 'review_requests')

/** Reads the review requests query key without subscribing to the query itself. */
export const useReviewRequestsQueryKey = () => useRouteQueryKey(useOverviewRoute(), 'review_requests')

export const useDevelopmentQuery = () => useRouteQuery(useOverviewRoute(), 'development')

export const useLabelsQuery = () => useRouteQuery(useOverviewRoute(), 'labels')

export const useParticipantsQuery = () => useRouteQuery(useOverviewRoute(), 'participants')

/** Automatically observes for live updates. */
export const useDeploymentsQuery = () => {
  const query = useRouteQuery(useOverviewRoute(), 'deployments')

  const dedupeConcurrentRefetches = isFeatureEnabled('merge_status_checks_refetch_dedupe')
  const aliveChannel = query.data?.aliveChannel ?? ''
  useRefetchOnAliveUpdate(dedupeConcurrentRefetches ? '' : aliveChannel, query.refetch)
  useInvalidateOnAliveUpdate(dedupeConcurrentRefetches ? aliveChannel : '', query.queryKey)

  return query
}
